import axios from 'axios'
import { BASE_URL, AUTH_ENDPOINTS } from 'common/constants/apiUrls'

const REFRESH_URL = BASE_URL + AUTH_ENDPOINTS.REFRESH

const clearUserCredentials = () => {
  localStorage.removeItem('userCredentials')
}

export const createAxiosInstance = (baseURL) => {
  const instance = axios.create({
    baseURL,
    withCredentials: true,
  })

  // Always attach the latest access token
  instance.interceptors.request.use((config) => {
    const accessToken = JSON.parse(localStorage.getItem('userCredentials') || '{}')?.access_token
    if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`
    return config
  })

  let refreshPromise = null
  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const status = error?.response?.status
      const originalRequest = error?.config
      if (!originalRequest) return Promise.reject(error)

      // Don't refresh on 404
      if (status !== 401 && status !== 403) return Promise.reject(error)

      // Never try to refresh if the refresh endpoint itself failed
      if (originalRequest.url?.includes(AUTH_ENDPOINTS.REFRESH)) {
        clearUserCredentials()
        window.location.reload()
        return Promise.reject(error)
      }

      // Retry guard
      if (originalRequest.retry) return Promise.reject(error)
      originalRequest.retry = true

      try {
        // Deduplicate concurrent refresh calls
        refreshPromise = refreshPromise || axios.post(REFRESH_URL, {}, { baseURL: BASE_URL, withCredentials: true })

        const resp = await refreshPromise
        refreshPromise = null

        const newAccessToken = resp?.data?.data?.access_token
        if (!newAccessToken) throw new Error('No access token returned from refresh')

        const userCred = JSON.parse(localStorage.getItem('userCredentials') || '{}')
        localStorage.setItem('userCredentials', JSON.stringify({ ...userCred, access_token: newAccessToken }))

        // Replay original request with new token
        originalRequest.headers = originalRequest.headers || {}
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`
        return authAxios(originalRequest)
      } catch (refreshErr) {
        refreshPromise = null
        clearUserCredentials()
        window.location.reload()
        return Promise.reject(refreshErr)
      }
    },
  )
  return instance
}

export const authAxios = createAxiosInstance(BASE_URL)

// TODO: REVERT THIS BACK TO THE REAL SERVER
export const publicAxios = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
})
